module.exports = __webpack_public_path__ + "img/create.06057cab.svg";